import { Skeleton, TableRow, TableCell, Box } from "@mui/material";
import { StyledTableRow } from "./TableBodyRows";
import { StyledTableCell } from "./TableHeader";

const TableSkeleton = ({
  columns,
  rows = 10,
  hasActions,
}: {
  columns: number;
  rows?: number;
  hasActions: boolean;
}) => (
  <>
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <StyledTableRow key={rowIdx} sx={{ height: 42 }}>
        {Array.from({ length: columns }).map((__, colIdx) => (
          <StyledTableCell key={colIdx}>
            <Skeleton
              variant="text"
              height={20}
              sx={{ fontSize: "1rem", lineHeight: 1 }}
            />
          </StyledTableCell>
        ))}
        {hasActions && (
          <StyledTableCell>
            <Box display="flex" justifyContent={"end"} gap={1}>
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </StyledTableCell>
        )}
      </StyledTableRow>
    ))}
  </>
);

export default TableSkeleton;
